import { useState } from 'react';
import ActivityCard from '../../../../Core/Activity/ActivityCard';
const Tab6 = ({
  setDisable, disable,
  setDelivery, delivery,
  setFrozen, frozen,
  setSalerOrder, salesorder,
  customerName
}) => {
  return (
   <div>
     <div className="row mb-3" style={{ border: "1px solid #00000059", borderRadius: "5px" }}>
      <div className="col-12">
        <p className="boxLabel m-0">Details</p>
      </div>

      {/* Wrapper for checkbox grid */}
      <div  className = 'mx-2 mb-3'style={{ display: 'flex', flexWrap: 'wrap', gap: '1rem' }}>
        {/* Row 1 */}
        <div style={{ flex: '0 0 48%' }}>
          <input
            type="checkbox"
            id="check1"
            checked={salesorder === 1}
            onChange={(e) => setSalerOrder(e.target.checked ? 1 : 0)}
          />
          <label htmlFor="check1" style={{ marginLeft: '0.5rem', fontSize: '13px', color: '#00000099' }}>
            Allow Sales Invoice Without Sales Order
          </label>
        </div>

        <div style={{ flex: '0 0 48%' }}>
          <input
            type="checkbox"
            id="check2"
            checked={frozen === 1}
            onChange={(e) => setFrozen(e.target.checked ? 1 : 0)}
          />
          <label htmlFor="check2" style={{ marginLeft: '0.5rem', fontSize: '13px', color: '#00000099' }}>
            Is Frozen
          </label>
        </div>

        {/* Row 2 */}
        <div style={{ flex: '0 0 48%' }}>
          <input
            type="checkbox"
            id="check3"
            checked={delivery === 1}
            onChange={(e) => setDelivery(e.target.checked ? 1 : 0)}
          />
          <label htmlFor="check3" style={{ marginLeft: '0.5rem', fontSize: '13px', color: '#00000099' }}>
            Allow Sales Invoice Without Delivery Note
          </label>
        </div>

        <div style={{ flex: '0 0 48%' }}>
          <input
            type="checkbox"
            id="check4"
            checked={disable === 1}
            onChange={(e) => setDisable(e.target.checked ? 1 : 0)}
          />
          <label htmlFor="check4" style={{ marginLeft: '0.5rem', fontSize: '13px', color: '#00000099' }}>
            Disabled
          </label>
        </div>
      </div>
    </div>
         <div className="">
                <ActivityCard doctype="Customer" docname={customerName} />
            </div>

   </div>
  );
};

export default Tab6;
